import {Article} from "types/Article";
import {dateTime} from "services/date";
import deserializeFile from "services/ngage/deserializers/file";
import deserializeTag from "services/ngage/deserializers/tag";

/**
 * Transform the given article by deserializing object properties
 *
 * @internal
 * @param article
 */
export default function deserializeArticle(article: any): Article {
    article.image = article.image ? deserializeFile(article.image) : null
    article.tags = article.tags?.map(deserializeTag) || []
    article.published_at = dateTime(article.published_at)
    article.created_at = dateTime(article.created_at)
    article.updated_at = dateTime(article.updated_at)

    return article;
}